require('./impositionInterestRenewalView.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { formatText } = require('core/i18n').i18n;
// @helpers
const { getLastNChars } = require('utilities/stringHelper');
const {
    getAccountByImposition,
    getFundsByImposition
} = require('utilities/currentAccountsHelper.js');
const {
    findFundByContractNumber,
    getFundDataForImposition,
} = require('utilities/investmentFundsHelper');
// @components
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const ImpositionInterestRenewalStep1 = require('./impositionInterestRenewalStep1/impositionInterestRenewalStep1');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
const { LoadingSection } = require('commonsComponents/loadingSection');
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
const PreleaveCancelModal = require('components/contactCenter/preleaveCancelModal/preleaveCancelModal');
const ImpositionSidebar = require('components/imposition/impositionSidebar/impositionSidebar');
// @consts
const { WIZARD_VERTICAL_VIEW_MODE, CHARGE_ACCOUNT_PREFIX } = require('constants/index');
const { IMPOSITION_INTEREST_RENEWAL } = require('constants/contactCenter/operationTypes');

class ImpositionInterestRenewalView extends React.Component {
    constructor(props) {
        super(props);
        this.handleShowCancelModal = this.handleShowCancelModal.bind(this);
        this.handleHideCancelModal = this.handleHideCancelModal.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.onHandleGoBack = this.onHandleGoBack.bind(this);

        this.state = {
            isRenewal: (props.match.params.isRenewal === 'S')
        };
    }

    componentDidMount() {
        const { immDeposits, requestDeposits } = this.props;

        if (!immDeposits.has('byId')) {
            requestDeposits();
        } else {
            this.getInterveners(this.props);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (
            !nextProps.immDeposits.get('isFetching') &&
            nextProps.immDeposits.get('success')
        ) {
            const accountId = this.getAccountId(nextProps);
            const {
                hasBeenFetched,
                isLoading,
                error
            } = nextProps.immAccounts.getIn(['byId', accountId, 'interveners']).toJS();

            if (!hasBeenFetched && !isLoading && !error) {
                this.getInterveners(nextProps);
            }
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    getAccountId(props) {
        const {
            match: { params: { depositId } },
            immDeposits,
            immAccounts
        } = props;

        const immImpositionAssociatedAccount = immDeposits.getIn(['byId', depositId, 'impositionAssociatedAccount']);
        const immAccount = getAccountByImposition(immImpositionAssociatedAccount, immAccounts);

        return immAccount.get('accountId');
    }

    getInterveners(nextProps) {
        const {
            match: { params: { depositId } },
            immDeposits,
            immAccounts,
        } = nextProps;

        const immDeposit = immDeposits.getIn(['byId', depositId]);
        const immImpositionAssociatedAccount = immDeposit.get('impositionAssociatedAccount');
        const immAccount = getAccountByImposition(immImpositionAssociatedAccount, immAccounts);
        const accountId = immAccount.get('accountId');

        this.props.requestInterveners(accountId);
    }

    buildPreleaveCancelModal() {
        const { immImpositionInterestRenewal } = this.props;
        const showCancelModal = immImpositionInterestRenewal.get('showCancelModal');

        return (
            <PreleaveCancelModal
                isOpen={showCancelModal}
                onCancel={this.handleCancel}
                onCloseModal={this.handleHideCancelModal}
                onStayHere={this.handleHideCancelModal}
            />
        );
    }

    handleShowCancelModal() {
        const { showCancelModal } = this.props;
        showCancelModal(true);
    }

    handleHideCancelModal() {
        const { showCancelModal } = this.props;
        showCancelModal(false);
    }

    handleCancel() {
        const {
            history,
            match: { params: { depositId, impositionId } },
        } = this.props;

        const cancelPath = `/myprofile/deposits/${depositId}/imposition/${impositionId}/`;
        history.push(cancelPath);
    }

    onHandleGoBack() {
        const impositionPath = '/myprofile/deposits';
        this.props.history.push(impositionPath);
    }

    buildHeader() {
        const {
            match: { params: { depositId, impositionId } }
        } = this.props

        const title = formatText('deposits-title');
        const operationTitle = this.state.isRenewal ? 'breadcrumb-impositionSetRenewal' : 'breadcrumb-impositionInterestRenewal';
        const breadcrumpMap = [
            {
                text: formatText('breadcrumb-deposits'),
                url: '/myprofile/deposits'
            },
            {
                text: formatText('breadcrumb-impositionDetail'),
                url: `/myprofile/deposits/${depositId}/imposition/${impositionId}`
            },
            {
                text: formatText(operationTitle)
            }
        ];

        return (
            <OKHeaderCC
                title={title}
                breadcrumbConfig={breadcrumpMap}
                showBreadBrumb={true}
            />
        );
    }

    handleFinish() {
        const {
            match: { params: { depositId, impositionId } },
            renewImpositionInterest,
            immDeposits,
        } = this.props;

        const immDeposit = immDeposits.getIn(['byId', depositId]);
        const contractNumber = immDeposit.getIn(['contract', 'contractNumber']).trim();
        const product = immDeposit.getIn(['contract', 'product']);

        renewImpositionInterest(impositionId, contractNumber, product, this.state.isRenewal);
    }

    buildSidebar() {

        const {
            match: { params: { depositId, impositionId } },
            immDeposits,
            immAccounts,
            immInvestmentFunds,
        } = this.props;

        const immDeposit = immDeposits.getIn(['byId', depositId]);
        const fullContractNumber = immDeposit.getIn(['contract', 'fullContractNumber']);
        const immImpositionAssociatedAccount = immDeposit.get('impositionAssociatedAccount');
        const immAccount = getAccountByImposition(immImpositionAssociatedAccount, immAccounts);
        const alias = immAccount.get('alias');
        const iban = immAccount.get('iban');
        const account = alias + ' ' + getLastNChars(iban);
        const immInterveners = immAccount.getIn(['interveners', 'list']) || [];
        const immImposition = immDeposit.getIn(['impositionList', 'byId', impositionId]);
        const immImpositions = immDeposit.get('impositionList');
        const fundsAmountTotal = getFundsByImposition(immImpositions);

        let fundData;
        if (fundsAmountTotal.amount > 0) {
            const investmentFund = findFundByContractNumber(immInvestmentFunds, immImposition.get('fundContract'));
            fundData = getFundDataForImposition(investmentFund);
        }

        return (
            <div className="col-xs-4">
                <ImpositionSidebar
                    title={immDeposit.get('description')}
                    amountObject={immDeposit.get('amount')}
                    contractNumber={fullContractNumber}
                    account={account}
                    isFetchingInterveners={immAccount.getIn([
                        'interveners',
                        'isLoading'
                    ])}
                    immInterveners={immInterveners}
                    fund={fundData}
                    immDeposits={immDeposits}
                    depositId={depositId}
                    impositionId={impositionId}
                    showImpositionNumber={true}
                />
            </div>
        );
    }

    buildSuccessfulFeedback() {
        const successFeedbackTitle = this.state.isRenewal ? 'impositionInterestRenewal-setRenewalSuccessFeedbackTitle' : 'impositionInterestRenewal-successfulFeedbackTitle';

        return (
            <CustomMessageBox
                icon="icon-success"
                title={formatText(successFeedbackTitle)}
                subtitle={formatText('impositionInterestRenewal-successfulFeedbackSubtitle')}
                textLink={formatText('impositionInterestRenewal-feedbackBackButton')}
                goBackHandler={this.onHandleGoBack}
            />
        );
    }

    buildErrorFeedback() {
        return (
            <CustomMessageBox
                icon="icon-warning"
                title={formatText('impositionInterestRenewal-failureFeedbackTitle')}
                subtitle={formatText('impositionInterestRenewal-failureFeedbackSubtitle')}
                textLink={formatText('impositionInterestRenewal-feedbackBackButton')}
                goBackHandler={this.onHandleGoBack}
            />
        );
    }

    buildWizard() {
        const {
            match: { params: { depositId, impositionId } },
            immDeposits,
            immProfile,
            setVisibleStep,
            validateStep,
            immImpositionInterestRenewal,
        } = this.props;

        const immDeposit = immDeposits.getIn(['byId', depositId]);
        const contractNumber = immDeposit.getIn(['contract', 'contractNumber']).trim();
        const product = immDeposit.getIn(['contract', 'product']);
        const depositContractNumber = `${CHARGE_ACCOUNT_PREFIX}${product}${contractNumber}`;

        const currentStep = immImpositionInterestRenewal.get('currentStep');
        const immSteps = immImpositionInterestRenewal.get('steps');
        const actions = {
            finish: this.handleFinish,
            setVisibleStep,
            validateStep,
            setWillCancel: () => { },
            cancel: this.handleShowCancelModal
        }

        const operationParams = {
            originAccount: depositContractNumber,
            optional1: impositionId,
        };

        return (
            <Wizard
                viewMode={WIZARD_VERTICAL_VIEW_MODE}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={2}
                visibleStep={currentStep}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                >
                    <ImpositionInterestRenewalStep1
                        immProfile={immProfile}
                        immDeposits={immDeposits}
                        depositId={depositId}
                        impositionId={impositionId}
                        isRenewal={this.state.isRenewal}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    omitPreviousButton={true}
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    isLoading={false}
                    immFinalButton="impositionInterestRenewal-confirm"
                >
                    <VerifyOtpStep
                        withValidateButton={false}
                        operationType={IMPOSITION_INTEREST_RENEWAL}
                        operationParams={operationParams}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildContent() {
        const { immDeposits, immImpositionInterestRenewal, immAccounts } = this.props;
        let pageContent;

        const isLoading =
            immDeposits.get('isFetching') ||
            (immDeposits.get('success') && immAccounts.getIn(['byId', this.getAccountId(this.props), 'interveners', 'isLoading'])) ||
            immImpositionInterestRenewal.get('isFetching');

        if (isLoading) {
            pageContent = <LoadingSection />
        }
        else {
            if ((!immDeposits.has('byId') && !!immDeposits.get('error')) ||
                !!immImpositionInterestRenewal.get('error')) {
                pageContent = this.buildErrorFeedback();
            } else if (immImpositionInterestRenewal.get('hasBeenFetched')) {
                pageContent = this.buildSuccessfulFeedback();
            } else if (immDeposits.has('byId') && immDeposits.get('success')) {
                const wizard = this.buildWizard();
                const preleaveCancelModal = this.buildPreleaveCancelModal();
                const content = (
                    <div className="col-xs-8">
                        {wizard}
                        {preleaveCancelModal}
                    </div>
                );
                const sidebar = this.buildSidebar();
                pageContent = (
                    <div>
                        {content}
                        {sidebar}
                    </div>
                );
            }
        }

        return pageContent;
    }

    render() {
        const header = this.buildHeader();
        const content = this.buildContent();

        return (
            <div className="imposition-interest-renewal">
                {header}
                <div className="imposition-interest-renewal__body">
                    {content}
                </div>
            </div>

        );
    }
}

ImpositionInterestRenewalView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immDeposits: PropTypes.object.isRequired,
    immInvestmentFunds: PropTypes.object.isRequired,
    requestDeposits: PropTypes.func.isRequired,
    immImpositionInterestRenewal: PropTypes.object.isRequired,
    renewImpositionInterest: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    requestInterveners: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    showCancelModal: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
};

module.exports = withRouter(ImpositionInterestRenewalView);
